import { render, staticRenderFns } from "./BrightPerformance.vue?vue&type=template&id=6b1b0f47"
import script from "./BrightPerformance.vue?vue&type=script&lang=js"
export * from "./BrightPerformance.vue?vue&type=script&lang=js"
import style0 from "./BrightPerformance.vue?vue&type=style&index=0&id=6b1b0f47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports